import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {KeycloakService} from "./app/core/services/keycloak.service";
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.log(err));


KeycloakService.init().then(data => {
  // console.log("success");
  // console.log(data);
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
}).catch(error => {
  // console.log("error");
  // console.log(error);
});



// WEBPACK FOOTER //
// ./src/main.ts